import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { FluVaccineUrl } from '../../shared/urls/flu-vaccine.url';
import * as moment from 'moment';
import { Utility } from '../../common/utility';

@Injectable()
export class FluBookingService {
  constructor(public baseService: BaseService) {

  }

  getFluBookingInfo(id) {
    const url = FluVaccineUrl.GET_FLU_BOOKING_INFO.replace('{id}', id);
    return this.baseService.getData(url);
  }

  getFluBookingList(id, staffId) {
    const url = FluVaccineUrl.GET_FLU_BOOKING_LIST.replace('{id}/{staffId}', id + '/' + staffId);
    return this.baseService.getData(url);
  }

  updateFluBooking(param) {
    const url = FluVaccineUrl.UPDATE_FLU_BOOKING;
    return this.baseService.put(url, param);
  }

  getPatientList(bookingId) {
    const url = Utility.stringFormat(FluVaccineUrl.GET_MEMBERS, [bookingId]);
    return this.baseService.getData(url);
  }

  convertBookingListToLocalTime(list) {
    list.forEach(i => {
        i = this.convertBookingItemToLocalTime(i);
    });
    return list;
  }
  

  convertDisableTimeToLocalTime(list, bookingDate) {
    list.forEach(item => {
      const startTime =  moment.utc(item['start']).local().format('YYYY-MM-DDTHH:mm:ss');
      const endTime =  moment.utc(item['end']).local().format('YYYY-MM-DDTHH:mm:ss');
      if (!moment(startTime).isSame(bookingDate, 'day')) {
        item['start'] = '00:00';
      } else {
        if (moment(item['start']).hour() === 0 && moment(item['start']).minute() === 0) {
          item['start'] = '00:00';
        } else {
          item['start'] = moment(startTime).format('HH:mm');
        }
      }

      if (moment(endTime).isBefore(bookingDate, 'day')) {
        item['end'] = '00:00';
      } else if (moment(endTime).isAfter(bookingDate, 'day')) {
        item['end'] = '24:00';
      } else {
       /*  if (moment(startTime).hour() > moment(endTime).hour() && !moment(endTime).isSame(bookingDate, 'day')) {
          item['end'] = '24:00';
        } else { */
          item['end'] = moment(endTime).format('HH:mm');
      //  }
      }
    });
    return list;
  }

  convertBookingItemToLocalTime(item) {
      item['start'] = moment.utc(item['start']).local().format('YYYY-MM-DDTHH:mm:ss');
      item['end'] =  moment.utc(item['end']).local().format('YYYY-MM-DDTHH:mm:ss');
      return item;
  }

  convertBookingDateToUTCString(date) {
    return moment(date).utc().format('YYYY-MM-DDTHH:mm:ss');
  }
}

/* const bookingList = [
  {
    id: '1',
    title: 'patient name patient name patient name 1', // booking ref or patient name
    class: 'Flu',
    start: '2018-02-09T01:00:00',
    end: '2018-02-09T01:15:00',
    readOnly: true
  },
  {
    id: '2',
    title: 'Nguyen Van A 2', // booking ref or patient name
    class: 'Flu',
    start: '2018-02-09T01:15:00',
    end: '2018-02-09T01:30:00',
    readOnly: true
  }
];

const bookingInfo = {
  bookingREF: 'B0001',
  bookingDate: '2018-02-09',
  bookingDuration: '20',
  staffs: [
    {
      id: 'staff1',
      name: 'staff 1'
    },
    {
      id: 'staff2',
      name: 'staff 2'
    }
  ],
  disableDates: [],
  disableTimes: [
       {
          start: "0:00",
          end: "8:00"
      },
      {
          start: "12:00",
          end: "13:00"
      },
      {
          start: "17:00",
          end: "24:00"
      }
  ]
};
 */


// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/flu-vaccine/flu-vaccine.service.ts